// Values are pinned: 4 was Drawout Sketch, removed with the feature. The backend stores this as a
// bare int (User.AppLastSession) with no enum of its own, so nothing else guards these numbers.
export enum DrawoutApps {
    Lite = 1,
    Zen = 2,
    Pro = 3,
    Test = 5
}